import React from 'react';
import '../CSS/App.css';
import '../CSS/About.css'
import img from '../Media/IMG_0225.png'

const About = () => {
  return (
    <div className='about-page'>
      <p className='title'>About me</p>

      <div className='about-hero'>
        <img className='about-image' src={img} alt="About me" />
        <div className='about-bio'>
          <p>Based in Los Angeles, I'm a Computer Science graduate from Cal State University Dominguez Hills.</p>
          <p>I have experience in both front-end and back-end development, with a strong preference for back-end and infrastructure work. I enjoy building and self-hosting my own projects — from full-stack web apps to home server setups running Docker, Nginx, and Ubuntu Server.</p>
          <p>Currently working as an IT Associate, with hands-on experience in enterprise IT support, Active Directory, and Linux system administration.</p>
          <p>Outside of tech, I like hiking and collecting retro technology.</p>
        </div>
      </div>

      <div className='about-section'>
        <p className='section-title'>Work Experience</p>

        <div className='work-entry'>
          <div className='work-role-line'>
            <span className='work-title'>IT Associate</span>
            <span className='work-date'>Dec 2025 – Present</span>
          </div>
          <span className='work-company'>UNIS — Buena Park, CA</span>
          <ul className='work-bullets'>
            <li>Delivered first and second-level technical support across desktops, laptops, printers, mobile devices, and peripherals, diagnosing LAN connectivity issues, downed ports, and access point failures while managing service requests.</li>
            <li>Provisioned and deployed IT hardware including imaging, configuring, and relocating desktops, laptops, and printers; administered user accounts and devices via Active Directory, MDM platforms, and remote support tools.</li>
            <li>Maintained asset records for $9M+ in company technology, tagging and tracking equipment inventory while documenting recurring issues and support workflows to reduce downtime and repeat tickets.</li>
          </ul>
        </div>

        <div className='work-entry'>
          <div className='work-role-line'>
            <span className='work-title'>IT Student Intern</span>
            <span className='work-date'>Aug – Dec 2025</span>
          </div>
          <span className='work-company'>CSUDH IT Service Desk — Carson, CA</span>
          <ul className='work-bullets'>
            <li>Resolved 30+ daily technical support tickets via ServiceNow, TeamViewer, and Microsoft Quick Assist, consistently meeting SLA benchmarks across Windows, macOS, and Linux systems.</li>
            <li>Troubleshot authentication and identity issues using Active Directory, Azure AD, Duo MFA, and SSO, restoring user accounts and reducing recurring login support tickets.</li>
            <li>Configured and supported endpoint hardware including printers and network devices using TCP/IP diagnostic tools and print management systems.</li>
          </ul>
        </div>

        <div className='work-entry'>
          <div className='work-role-line'>
            <span className='work-title'>Java Instructor</span>
            <span className='work-date'>Jun – Aug 2025</span>
          </div>
          <span className='work-company'>iDTech Camp — New York, NY</span>
          <ul className='work-bullets'>
            <li>Delivered Java programming instruction to K-8 students covering OOP fundamentals, Eclipse IDE, and project-based learning, guiding all students to complete final projects.</li>
          </ul>
        </div>
      </div>

      <div className='about-section'>
        <p className='section-title'>Technologies</p>

        <div className='tech-group'>
          <p className='tech-category'>Languages</p>
          <ul className='tech-list'>
            <li>Java</li>
            <li>Python</li>
            <li>JavaScript</li>
            <li>C</li>
            <li>SQL</li>
            <li>Bash</li>
            <li>HTML/CSS</li>
          </ul>
        </div>

        <div className='tech-group'>
          <p className='tech-category'>Frameworks & Databases</p>
          <ul className='tech-list'>
            <li>React</li>
            <li>Node.js</li>
            <li>Express.js</li>
            <li>MySQL</li>
            <li>MongoDB</li>
            <li>REST APIs</li>
            <li>JWT Auth</li>
            <li>Hugging Face</li>
            <li>LoRA Fine-Tuning</li>
          </ul>
        </div>

        <div className='tech-group'>
          <p className='tech-category'>Infrastructure & DevOps</p>
          <ul className='tech-list'>
            <li>Linux/Ubuntu</li>
            <li>Docker</li>
            <li>Docker Compose</li>
            <li>Nginx</li>
            <li>Nginx Proxy Manager</li>
            <li>Bash Scripting</li>
            <li>KVM/QEMU</li>
            <li>Virtualization</li>
            <li>Pi-hole/AdGuard</li>
            <li>Reverse Proxy</li>
          </ul>
        </div>

        <div className='tech-group'>
          <p className='tech-category'>Systems & Networking</p>
          <ul className='tech-list'>
            <li>Active Directory</li>
            <li>Azure AD</li>
            <li>MFA/SSO</li>
            <li>IAM</li>
            <li>ServiceNow</li>
            <li>TCP/IP</li>
            <li>Firewall & DNS</li>
            <li>Network Security</li>
            <li>System Administration</li>
          </ul>
        </div>

        <div className='tech-group'>
          <p className='tech-category'>Tools</p>
          <ul className='tech-list'>
            <li>Git</li>
            <li>GitHub</li>
            <li>VS Code</li>
            <li>IntelliJ</li>
            <li>TeamViewer</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
